import { h } from 'preact';
import { formatMoney } from '../../core/shopify/format-money';
import { getSizedImageUrl } from '../../core/shopify/get-sized-image-url';
import { isPresent } from '../../core/typescript/guards';
const locale = {
    qtyLabel: 'Quantity',
    reduceQty: 'Reduce quantity',
    increaseQty: 'Increase quantity'
};
const updateQuantityAndTrack = (item, newQuantity, changeQuantity)=>{
    const isAdd = newQuantity > item.quantity;
    const isRemove = newQuantity < item.quantity;
    changeQuantity({
        items: [
            {
                lineItemKey: item.key,
                quantity: newQuantity
            }
        ]
    });
    if (isAdd || isRemove) {
        const eventType = isAdd ? 'add_to_cart' : 'remove_from_cart';
        const eventKey = isAdd ? 'productsToAdd' : 'productsToRemove';
        const isCartPage = document.body.getAttribute('data-shopify-template') === 'cart';
        const eventSource = isCartPage ? 'cart_page' : 'mini_cart';
        Shopify.analytics.publish(eventType, {
            event: isAdd ? 'Add to Cart' : 'Remove from Cart',
            [eventKey]: [
                {
                    sku: item.sku,
                    name: item.product_title,
                    variantName: item.title,
                    price: item.price,
                    productType: item.product_type,
                    quantity: 1
                }
            ],
            source: eventSource
        });
    }
};
export const CartDrawerItem = function({ item , moneyFormat , changeQuantity , giftBoxesTooltipTitle , giftBoxesDescriptions  }) {
    var _item_title, _item_title1;
    if (item.handle == null) {
        // Don't render items with missing product
        return null;
    }
    const itemImage = getSizedImageUrl(item.featured_image.url);
    const itemProperties = Object.entries(item.properties || {}).filter(function(entry) {
        return isPresent(entry[1]);
    }).filter(function rejectPrivateProperties([key]) {
        return key.slice(0, 1) !== '_';
    });
    const removeQtyIcon = h('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 10 11'
    }, h('path', {
        d: 'M7.687 2.393 5 5.08 2.313 2.393a.6.6 0 1 0-.849.849l2.687 2.687-2.687 2.687a.6.6 0 1 0 .849.848L5 6.777l2.687 2.688a.6.6 0 1 0 .849-.849L5.848 5.93l2.687-2.687a.6.6 0 1 0-.848-.849z'
    }));
    const reduceQtyIcon = h('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 10 11'
    }, h('path', {
        d: 'M9.4 5.329H.6a.6.6 0 1 0 0 1.2h8.8a.6.6 0 1 0 0-1.2z'
    }));
    const increaseQtyIcon = h('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 10 11'
    }, h('path', {
        d: 'M9.4 5.114H5.6v-3.8a.6.6 0 1 0-1.2 0v3.8H.6a.6.6 0 1 0 0 1.2h3.8v3.8a.6.6 0 1 0 1.2 0v-3.8h3.8a.6.6 0 1 0 0-1.2Z'
    }));
    const giftBoxDescription = giftBoxesDescriptions && giftBoxesDescriptions.find((i)=>item.product_id === i.id);
    return h('div', {
        className: 'CartItem'
    }, h('div', {
        className: 'CartItem-section is-image'
    }, ((_item_title = item.title) === null || _item_title === void 0 ? void 0 : _item_title.includes('Gift Box')) ? h('div', {
        className: 'CartItem-imagePlaceholder o-placeholder lazyload',
        style: {
            backgroundImage: itemImage ? `url('${itemImage}')` : null
        }
    }) : h('a', {
        className: 'CartItem-imageLink',
        href: item.url,
        title: 'image of ' + item.title,
        tabindex: '-1'
    }, [
        h('div', {
            className: 'CartItem-imagePlaceholder o-placeholder lazyload',
            style: {
                backgroundImage: itemImage ? `url('${itemImage}')` : null
            }
        })
    ])), h('div', {
        className: 'CartItem-section is-info'
    }, [
        h('div', {
            className: 'CartItem-header'
        }, [
            ((_item_title1 = item.title) === null || _item_title1 === void 0 ? void 0 : _item_title1.includes('Gift Box')) ? h('span', {
                className: 'CartItem-title'
            }, item.product_title || '') : h('a', {
                className: 'CartItem-title',
                href: item.url,
                tabindex: '-1'
            }, item.product_title || ''),
            h('div', {
                className: 'CartItem-price',
                innerHTML: formatMoney(item.line_price, moneyFormat)
            })
        ]),
        h('div', {
            className: 'CartItem-variantTitle'
        }, function() {
            const variantTitle = item.variant_title || '';
            if (variantTitle.toLowerCase().indexOf('Default') >= 0) {
                return '';
            }
            return variantTitle;
        }(), giftBoxDescription && h('div', {
            className: 'Cart-infoIcon',
            innerHTML: '<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10.3135" r="10" fill="#D3D3D3" /><path d="M9.50091 9.48775H10.8294V14.2026H9.50091V9.48775ZM9.37025 7.49508C9.37025 7.05952 9.72958 6.70019 10.1651 6.70019C10.6007 6.70019 10.96 7.05952 10.96 7.49508C10.96 7.93064 10.6007 8.28997 10.1651 8.28997C9.72958 8.28997 9.37025 7.93064 9.37025 7.49508Z" fill="white" /></svg>'
        }, h('div', {
            className: 'Cart-infoTooltip'
        }, h('span', {
            className: 'Cart-infoTooltipTitle'
        }, giftBoxesTooltipTitle), h('span', {
            className: 'Cart-infoTooltipSubtitle'
        }, item.title), h('p', {
            className: 'Cart-infoTooltipText'
        }, giftBoxDescription.description))), {
            className: 'CartItem-section is-price'
        }),
        h('dl', {
            className: 'CartItem-properties'
        }, ...itemProperties.map(function([key, value]) {
            const showKey = key === value || key === 'Sale' || key === 'Final Sale' ? ' --hide' : '';
            return [
                h('dt', {
                    className: 'CartItem-propertyTitle' + showKey
                }, key === value || key === 'Sale' ? '' : key),
                h('dd', {
                    className: 'CartItem-propertyValue'
                }, value)
            ];
        }))
    ], {
        className: 'CartItem-section is-qty'
    }, [
        h('div', {
            className: 'o-qtyControls CartItem-qtyContainer',
            id: 'qty-container'
        }, [
            h('button', {
                className: 'js-cart-drawer-qty o-qtyControls-button',
                type: 'button',
                'data-action': 'minus',
                'data-product-title': item.product_title,
                'data-product-sku': item.sku,
                'data-variant-name': item.title,
                'data-product-price': item.price,
                'data-product-type': item.product_type || 'Unknown',
                tabindex: '-1',
                onKeyUp: function decreaseQtyAcc(evt) {
                    if (evt.keyCode === 13) {
                        updateQuantityAndTrack(item, item.quantity - 1, changeQuantity);
                    }
                },
                onClick: function decreaseQty(evt) {
                    evt.preventDefault();
                    updateQuantityAndTrack(item, item.quantity - 1, changeQuantity);
                }
            }, h('div', {
                className: 'u-vhide'
            }, locale.reduceQty), h('div', {
                className: 'o-placeholder'
            }, item.quantity === 1 ? removeQtyIcon : reduceQtyIcon)),
            h('div', {
                className: 'o-qtyControls-indicator'
            }, [
                h('span', {
                    className: 'u-vhide'
                }, locale.qtyLabel),
                item.quantity
            ]),
            h('button', {
                className: 'js-cart-drawer-qty o-qtyControls-button',
                type: 'button',
                'data-action': 'plus',
                'data-product-title': item.product_title,
                'data-product-sku': item.sku,
                'data-variant-name': item.title,
                'data-product-price': item.price,
                'data-product-type': item.product_type || 'Unknown',
                tabindex: '-1',
                onKeyUp: function increaseQtyAcc(evt) {
                    if (evt.keyCode === 13) {
                        updateQuantityAndTrack(item, item.quantity + 1, changeQuantity);
                    }
                },
                onClick: function increaseQty(evt) {
                    evt.preventDefault();
                    updateQuantityAndTrack(item, item.quantity + 1, changeQuantity);
                }
            }, h('div', {
                className: 'u-vhide'
            }, locale.increaseQty), h('div', {
                className: 'o-placeholder'
            }, increaseQtyIcon))
        ])
    ]));
};
